import { useRef, useEffect } from 'react';
import {
  Button,
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

export const UploadCancelDialog = ({ show, title, text, continueHandler, cancelUploadsHandler, closeDialog }) => {
  const buttonRef = useRef(null);

  const handleContinue = () => {
    continueHandler();
    closeDialog();
  };

  const handleCancelUploads = () => {
    cancelUploadsHandler();
    closeDialog();
  };

  useEffect(() => {
    const { current } = buttonRef;
    if (current) current.focus();
  }, [show]);

  const handleDialogClose = (_, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      handleContinue();
      return;
    }
    closeDialog();
  };

  if (!show) return null;

  return (
    <MuiDialog
      open={show}
      onClose={handleDialogClose}
      aria-labelledby="upload-cancel-dialog-title"
      aria-describedby="upload-cancel-dialog-description"
    >
      <DialogTitle
        id="upload-cancel-dialog-title"
        sx={{ p: 2 }}
      >
        <Typography
          variant="span"
          sx={{ fontWeight: 400, fontSize: '16px' }}
        >
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Stack
          justifyContent="center"
          alignItems="center"
          spacing={2}
          sx={{ height: '100%', width: '380px', px: 4, textAlign: 'center' }}
        >
          <WarningAmberIcon sx={{ fontSize: 100, color: 'secondary.dark' }} />
          <Typography
            component="h5"
            variant="body1"
            sx={{ fontWeight: 500, fontSize: '18px' }}
          >
            Are you sure?
          </Typography>
          <Typography
            id="upload-cancel-dialog-description"
            component="p"
            variant="subtitle2"
            sx={{ fontWeight: 100, px: 2, width: '100%', textWrap: 'pretty', color: '#9ba29e' }}
          >
            {text}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button
          variant="contained"
          onClick={handleContinue}
          autoFocus
          sx={{
            boxShadow: 'none',
            textTransform: 'none',
            letterSpacing: 1.2,
            px: 2.5,
          }}
        >
          Continue uploads
        </Button>
        <Button
          variant="ghost"
          color="inherit"
          ref={buttonRef}
          onClick={handleCancelUploads}
          sx={{
            textTransform: 'none',
            letterSpacing: 1.2,
            px: 2.5,
          }}
        >
          Cancel all uploads
        </Button>
      </DialogActions>
    </MuiDialog>
  );
};
